import { memo, useEffect, useRef, useState } from "react";
import { styled } from "styletron-react";
import { colors, fonts } from "../../../Styles";

interface PathProps {
  $isSelected?: boolean;
  $locationVisual?: number;
  $attentionLevel?: number;
}

const StationPathStyle = styled<"path", PathProps>("path", (props) => ({
  stroke: "none",
  fill: colors.greyTertiary,
  filter: props.$isSelected ? "opacity(1)" : "opacity(0.5)"
}))

const AttentionPathStyle = styled<"path", PathProps>("path", (props) => ({
  stroke: "none",
  fill: props.$attentionLevel !== undefined && props.$attentionLevel === 0 ? colors.systemRed : props.$attentionLevel === 5 ? colors.graphBlueTwo : colors.systemYellow,
  filter: props.$isSelected ? "opacity(1)" : "opacity(0.5)",
  transformOrigin: props.$locationVisual !== undefined && props.$locationVisual >= 2 ? "0 50%" : "100% 50%", 
  transform: "scaleX(0)",      
  animation: "expand 0.5s forwards",
  "@keyframes expand": {
    "0%": { transform: "scaleX(0)" },
    "100%": { transform: "scaleX(1)" },
  },
}))

const ArrowPathStyle = styled<"path", PathProps>("path", (props) => ({
  stroke: "none",
  fill: colors.whitePrimary,
  filter: props.$isSelected ? "opacity(1)" : "opacity(0.5)",
}))

export const StationLocationVisualWalkIn = memo(({ content, attention, locationVisual, gridArea, onClick, isSelected = false}: { content: string | JSX.Element, attention?: number, locationVisual: number, gridArea?: string, onClick?: () => void, isSelected?: boolean }) => {
  let stationPath: string = "";
  let attentionPath:string = "";
  let firstArrowPath:string = "";
  let secondArrowPath: string = "";

  switch (locationVisual) {
    case 2:
      stationPath = "M118 4.48V27.93C118 30.40 115.99 32.40 113.52 32.40H23.32L4.48 32.40C2.01 32.40 0 30.40 0 27.93V4.48C0 2.01 2.01 0 4.48 0H9.14H113.52C115.99 0 118 2.01 118 4.48Z"
      attentionPath =   "M0 29C0 30.657 1.343 32.5 3 32.5H10V0H3C1.343 0 0 1.343 0 3V29Z"
      firstArrowPath = "M111 22.5L101.7 28.1L101.7 24.9L90.5 24.9L90.5 20.2L101.7 20.2L101.7 17L111 22.5Z"
      secondArrowPath = "M89.5 10.3L98.8 4.7L98.8 7.9L110 7.9L110 12.6L98.8 12.6L98.8 15.8L89.5 10.3Z"
    break
    case 1:
    default:
      stationPath =   "M118 4.48V27.93C118 30.40 115.99 32.40 113.52 32.40H23.32L4.48 32.40C2.01 32.40 0 30.40 0 27.93V4.48C0 2.01 2.01 0 4.48 0H9.14H113.52C115.99 0 118 2.01 118 4.48Z"
      attentionPath =       "M118 29C118 30.657 116.657 32.5 115 32.5H108V0H115C116.657 0 118 1.343 118 3V29Z"
      firstArrowPath = "M28.5 22.5L19.2 28.1L19.2 24.9L8 24.9L8 20.2L19.2 20.2L19.2 17L28.5 22.5Z"
      secondArrowPath = "M7 10.3L16.3 4.7L16.3 7.9L27.5 7.9L27.5 12.6L16.3 12.6L16.3 15.8L7 10.3Z"
    break
  } 

  return (
    <div style={{ position: "relative", cursor: "pointer", height: "32px", width: "118px", gridArea: gridArea ? gridArea : "" }} onClick={onClick ? onClick : undefined}>
      <svg viewBox="0 0 118 32">
        <StationPathStyle d={stationPath} $isSelected={isSelected}/>
        <ArrowPathStyle d={firstArrowPath} $isSelected={isSelected}/>
        <ArrowPathStyle d={secondArrowPath} $isSelected={isSelected}/>
        { attention !== undefined && <AttentionPathStyle d={attentionPath} $locationVisual={locationVisual} $isSelected={isSelected} $attentionLevel={attention}/>}
      </svg>
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "100%",
        height: "100%",
        // inset: locationVisual >= 3 ? "5px 10px 0px 0px" : "5px 0px 0px 10px",
        backgroundColor: colors.transparent,
        pointerEvents: "none",
        whiteSpace: "nowrap",
        color: colors.greyDarkPrimary,
        ...fonts.paragraph,
        ...fonts.fontSize4
      }}>
        {content}
      </div>
    </div>
  )
})